// import {  gql } from '@apollo/client';
import Mutation from './mutations';
import Query from './queries';

export const resolvers = {
    Mutation,
    Query,
}